import { connect } from "react-redux";

import Datenlogs from "./Datenlogs";

export default connect(state => ({
	today: new Date(state.rtc),
	auth: state.user
}))(Datenlogs);
